/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_Metric_Load_HintInputs */

const en_us2_exercise_personal_goal_metric_load_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_Load_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The heaviest weight you have used in a set of this exercise, for any number of reps.`)
};

const pt_br2_exercise_personal_goal_metric_load_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_Load_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso mais alto que você já usou numa série deste exercício, com qualquer número de repetições.`)
};

const es_419_exercise_personal_goal_metric_load_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_Load_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El peso más alto que has usado en una serie de este ejercicio, con cualquier número de repeticiones.`)
};

const pt_pt2_exercise_personal_goal_metric_load_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_Load_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso mais alto que já usaste numa série deste exercício, com qualquer número de repetições.`)
};

const fr_fr2_exercise_personal_goal_metric_load_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_Load_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La charge la plus lourde que tu as utilisée sur une série de cet exercice, quel que soit le nombre de répétitions.`)
};

const de_de2_exercise_personal_goal_metric_load_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_Load_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das höchste Gewicht, das du in einem Satz dieser Übung genutzt hast, bei beliebig vielen Wiederholungen.`)
};

const it_it2_exercise_personal_goal_metric_load_hint = /** @type {(inputs: Exercise_Personal_Goal_Metric_Load_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il peso più alto che hai usato in una serie di questo esercizio, con qualsiasi numero di ripetizioni.`)
};

/**
* | output |
* | --- |
* | "The heaviest weight you have used in a set of this exercise, for any number of reps." |
*
* @param {Exercise_Personal_Goal_Metric_Load_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_metric_load_hint = /** @type {((inputs?: Exercise_Personal_Goal_Metric_Load_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Metric_Load_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_metric_load_hint(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_metric_load_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_metric_load_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_metric_load_hint(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_metric_load_hint(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_metric_load_hint(inputs)
	return en_us2_exercise_personal_goal_metric_load_hint(inputs)
});
export { exercise_personal_goal_metric_load_hint as "exercise-personal.goal_metric_load_hint" }